import { render, staticRenderFns } from "./shortcutKeyList.vue?vue&type=template&id=32b65a1f&scoped=true&"
import script from "./shortcutKeyList.vue?vue&type=script&lang=js&"
export * from "./shortcutKeyList.vue?vue&type=script&lang=js&"
import style0 from "./shortcutKeyList.vue?vue&type=style&index=0&id=32b65a1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b65a1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32b65a1f')) {
      api.createRecord('32b65a1f', component.options)
    } else {
      api.reload('32b65a1f', component.options)
    }
    module.hot.accept("./shortcutKeyList.vue?vue&type=template&id=32b65a1f&scoped=true&", function () {
      api.rerender('32b65a1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/common/shortcutKeyList.vue"
export default component.exports